import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CollectUserEventSerVice {
  dataEvent: TrackActionPageDetailsModel;
  MAX_SIZE: number = 2048; // 2KB in bytes

  constructor(private http: HttpClient) {}

  getDataEvent(): TrackActionPageDetailsModel {
    return this.dataEvent;
  }

  initDataView(userId: string): void {
    try {
      const pageViewStore = localStorage.getItem(environment.PAGE_VIEW_DATA);
      if (pageViewStore && pageViewStore !== undefined && pageViewStore !== 'undefined') {
        const localData = pageViewStore ? JSON.parse(pageViewStore) : {};
        if (localData.sessionId === userId) {
          this.dataEvent = localData;
        } else {
          if (localData?.dataArray && localData.dataArray.length > 0) {
            this.dataEvent = localData;
            this.postActionEvent();
          }
          this.initDataEvent(userId);
        }
        localStorage.removeItem(environment.PAGE_VIEW_DATA);
      } else {
        this.initDataEvent(userId);
      }
    } catch (error) {
      console.log('initDataView error', error);
    }
  }

  initDataEvent(userId: string) {
    this.dataEvent = {
      platform: 'Web',
      screenSize: `${window.innerWidth.toString()}x${window.innerHeight.toString()}`,
      createdAt: Date.now(),
      sessionId: userId,
      location: localStorage.getItem('currentCountryCode') ?? '',
      language: localStorage.getItem('lang') ?? '',
      dataArray: [],
    };
  }

  collectActionEvent(carId: string, action: 'V' | 'C' | 'VI' = 'V'): void {
    const existingEvent = this.dataEvent?.dataArray?.find(
      (event) => event.d === carId && event.a === action
    );
    if (existingEvent) {
      if (Date.now() - existingEvent?.lastCountTime! > environment.CAN_COUNT_VIEW_DATA) {
        existingEvent.co += 1; // Increment the count
        existingEvent.lastCountTime = Date.now(); // Update the last count time
      }
    } else {
      const viewEvent: TrackActionPageModel = {
        m: 'car_rental',
        c: 'C',
        a: action,
        co: 1,
        d: carId,
        lastCountTime: Date.now(),
      };
      this.dataEvent?.dataArray.push(viewEvent);
      const dataEventSize = new Blob([JSON.stringify(this.dataEvent)]).size;
      if (dataEventSize > this.MAX_SIZE) {
        this.postActionEvent();
      }
    }
  }

  postActionEvent(): void {
    const url = `${environment.baseURL}/interaction-hub/interaction`;
    if (this.dataEvent?.dataArray.length === 0) {
      return;
    }
    this.dataEvent.dataArray = this.dataEvent?.dataArray.map((event) => {
      return {
        m: event.m,
        c: event.c,
        a: event.a,
        d: event.d,
        co: event.co,
      };
    });
    this.http.post(url, this.dataEvent).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.dataEvent.dataArray = [];
          this.dataEvent.createdAt = Date.now();
        }
      },
      error: (error) => {
        console.error('Error posting event data:', error);
      },
    });
  }
}

export interface TrackActionPageDetailsModel {
  platform: 'Web' | 'Android' | 'IOS'; // Web, Android, IOS
  screenSize: string;
  createdAt: number;
  sessionId: string; //userID
  location?: string; //Country code
  language?: string;
  age?: string;
  gender?: string;
  dataArray: TrackActionPageModel[];
}
export interface TrackActionPageModel {
  m: string; //travel_tour | car_rental
  c: string; // TOUR("T"), CAR("C")
  a: 'V' | 'C' | 'VI'; // VIEW("V"), CLICK("C"), VISIT("VI")
  d: string; // id tour | id car
  co: number; // count action
  l?: string; // empty string
  md?: null; // null
  mdCount?: null; // null
  lastCountTime?: number; // null
}
